module.exports = __webpack_public_path__ + "media/src/images/icon__mail-eebb1d477ccadbf56b66c34e0a8b4926.png";